import { z } from 'zod';

export const emailVerificationMailResDto = z.object({
  success: z.boolean(),
});
export type EmailVerificationMailResDto = z.infer<
  typeof emailVerificationMailResDto
>;
